import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { Spinner } from '../components/UI';
import EditorPaquetes from '../components/EditorPaquetes';

export default function EditarOrden({ idOrden, onGuardado, onCancelar }) {
  const [orden, setOrden] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [paquetes, setPaquetes] = useState([]);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api(`/ordenes/${idOrden}?incluir_costos_internos=true`).then(o => {
      setOrden(o);
      setPaquetes(o.paquetes.map(p => ({
        nombre: p.nombre,
        precio: p.precio,
        tareas: p.tareas.map(t => ({ descripcion: t.descripcion })),
        repuestos: p.repuestos.map(r => ({
          nombre: r.nombre, detalle: r.detalle || '',
          codigo: r.codigo || '', costo_taller: r.costo_taller || '', costo: ''
        })),
        costo_repuestos: 0, costo_mano_obra: 0, comision_ml_pct: 15, iva_pct: 22,
      })));
      setCargando(false);
    });
  }, [idOrden]);

  const guardar = async () => {
    setGuardando(true); setError('');
    try {
      await api(`/ordenes/${idOrden}`, {
        method: 'PATCH',
        body: JSON.stringify({
          paquetes: paquetes.map(p => ({
            nombre: p.nombre,
            precio: parseFloat(p.precio) || 0,
            tareas: p.tareas.filter(t => t.descripcion.trim()),
            repuestos: p.repuestos.filter(r => r.nombre.trim()).map(r => ({
              ...r, costo_taller: parseFloat(r.costo_taller) || 0
            })),
          })),
        })
      });
      onGuardado();
    } catch (e) {
      setError(e.message);
    }
    setGuardando(false);
  };

  if (cargando) return <div className="page-content"><Spinner texto="Cargando orden..." /></div>;
  if (!orden) return null;

  const total = paquetes.reduce((a, p) => a + (parseFloat(p.precio) || 0), 0);

  return (
    <div className="page-content">
      <div className="sec-header">
        <h2 className="page-title" style={{ marginBottom: 0 }}>Editar orden {orden.id}</h2>
        <button className="btn btn-secondary btn-sm" onClick={onCancelar}>← Cancelar</button>
      </div>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <div className="resumen-grid">
          <div className="resumen-card"><div className="label">Cliente</div><div className="valor">{orden.nombre_cliente}</div></div>
          <div className="resumen-card"><div className="label">Vehículo</div><div className="valor">{orden.marca} {orden.modelo}</div></div>
          <div className="resumen-card"><div className="label">Matrícula</div><div className="valor">{orden.matricula || '—'}</div></div>
        </div>
      </div>

      <EditorPaquetes paquetes={paquetes} setPaquetes={setPaquetes}
        vehiculo={{ marca: orden.marca, modelo: orden.modelo }} mostrarCalculadora={false} />

      {total > 0 && (
        <div style={{
          background: 'var(--azul)', color: 'white', borderRadius: 'var(--radio)',
          padding: '.75rem 1.25rem', display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', marginBottom: '1rem', fontWeight: 600
        }}>
          <span>TOTAL ESTIMADO</span>
          <span>${total.toLocaleString('es-UY', { maximumFractionDigits: 0 })}</span>
        </div>
      )}

      {error && <p style={{ color: 'var(--rojo)', marginBottom: '.75rem', fontSize: '.875rem' }}>{error}</p>}
      {guardando && <Spinner texto="Guardando..." />}

      <div style={{ display: 'flex', gap: '.5rem' }}>
        <button className="btn btn-secondary" onClick={onCancelar} disabled={guardando}>Cancelar</button>
        <button className="btn btn-primary" style={{ flex: 1 }} disabled={paquetes.length === 0 || guardando} onClick={guardar}>
          ✅ Aceptar y guardar cambios
        </button>
      </div>
    </div>
  );
}
